import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Trans, useTranslation } from 'react-i18next';

export const RboFormatValidationContent = () => {
  const { t } = useTranslation();

  return (
    <Box sx={{ p: 2 }} data-test="dialog-content">
      <Typography>
        <Trans
          t={t}
          i18nKey="Engagement optimization is only applicable for <b>Banner</b> or <b>Video</b> Inventory Targeting, and will be disabled above upon saving deal."
          components={{ b: <strong /> }}
        >
          Engagement optimization is only applicable for <strong>Banner</strong> or <strong>Video</strong> Inventory
          Targeting, and will be disabled above upon saving deal.
        </Trans>
      </Typography>
    </Box>
  );
};
